var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"back-button",on:{"click":_vm.previous}},[_c('font-awesome-icon',{attrs:{"icon":"arrow-alt-circle-left","size":"2x"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }